import Vue from 'vue';
import Vuex from 'vuex';
import Airtable from 'airtable';
import axios from 'axios';
import {orderBy} from 'lodash'

let base = new Airtable({apiKey: 'keyyYOEsQi6A1DFJ8'}).base('appfSIRJvrtchMwPT');

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    usuario: {},
    presentacion: {},
    cotizaciones: [],
    tipos_proyectos: [],
    proyectos: [],
    conceptos: [],
    tipos_productos: [],
    productos: [],
    condiciones: [],
    loading: 0,
    nomenclatura: window.location.pathname.replace("/", "").replace("/", ""),
  },
  mutations: {
    /*
     * AGREGAR
     */
    AGREGAR_USUARIO: (state, usuario) => {
      Vue.set(state, "usuario", usuario);
    },
    AGREGAR_PRESENTACION: (state, presentacion) => {
      Vue.set(state, "presentacion", presentacion);
    },
    AGREGAR_COTIZACIONES: (state, cotizaciones) => {
      state.cotizaciones.push(...cotizaciones);
    },
    AGREGAR_TIPOS_PROYECTOS: (state, tipos_proyectos) => {
      state.tipos_proyectos.push(...tipos_proyectos);
    },
    AGREGAR_PROYECTOS: (state, proyectos) => {
      state.proyectos.push(...proyectos);
    },
    AGREGAR_CONCEPTOS: (state, conceptos) => {
      state.conceptos.push(...conceptos);
    },
    AGREGAR_TIPOS_PRODUCTOS: (state, tipos_productos) => {
      state.tipos_productos.push(...tipos_productos);
    },
    AGREGAR_PRODUCTOS: (state, productos) => {
      state.productos.push(...productos);
    },
    AGREGAR_CONDICIONES: (state, condiciones) => {
      state.condiciones.push(...condiciones);
    },

    /*
     * LIMPIAR
     */
    LIMPIAR_USUARIO: (state) => {
      state.usuario = {};
    },
    LIMPIAR_PRESENTACION: (state) => {
      state.presentacion = {};
    },
    LIMPIAR_COTIZACIONES: (state) => {
      state.cotizaciones = [];
    },
    LIMPIAR_PROYECTOS: (state) => {
      state.proyectos = [];
    },
    LIMPIAR_TIPOS_PROYECTOS: (state) => {
      state.tipos_proyectos = [];
    },
    LIMPIAR_CONCEPTOS: (state) => {
      state.conceptos = [];
    },
    LIMPIAR_TIPOS_PRODUCTOS: (state) => {
      state.tipos_productos = [];
    },
    LIMPIAR_PRODUCTOS: (state) => {
      state.productos = [];
    },
    LIMPIAR_CONDICIONES: (state) => {
      state.condiciones = [];
    },

  },
  actions: {
    obtenerUsuario({rootState, commit}, {user, password}) {
      commit("LIMPIAR_USUARIO");
      rootState.loading++;
      return new Promise(((resolve, reject) => {
        base("usuarios").select({filterByFormula: `AND("${user}"=nombre, "${password}"=password)`}).eachPage((records, fetchNextPage) => {
          if (records.length === 1) {
            commit("AGREGAR_USUARIO", records[0]);
          }
          fetchNextPage();
        }, (err) => {
          if (err) {
            console.error(err);
            reject();
          } else {
            resolve();
          }
          rootState.loading--;
        });
      }));
    },
    obtenerPresentacion({rootState, commit}) {
      commit("LIMPIAR_PRESENTACION");
      return new Promise(((resolve, reject) => {
        rootState.loading++;
        base("presentaciones").select({filterByFormula: `AND('${rootState.nomenclatura}'=nomenclatura)`}).eachPage((records, fetchNextPage) => {
          if (records.length === 1) {
            commit("AGREGAR_PRESENTACION", records[0]);
          }
          fetchNextPage();
        }, (err) => {
          rootState.loading--;
          if (err) {
            console.error(err);
            reject();
          } else {
            resolve();
          }
        });
      }));
    },
    obtenerCotizaciones({rootState, commit}) {
      commit("LIMPIAR_COTIZACIONES");

      return new Promise(((resolve, reject) => {
        rootState.loading++;
        base("cotizaciones").select({filterByFormula: `FIND('${rootState.presentacion.id}', idsPresentaciones)`}).eachPage((records, fetchNextPage) => {
          commit("AGREGAR_COTIZACIONES", records);
          fetchNextPage();
        }, (err) => {
          rootState.loading--;
          if (err) {
            console.error(err);
            reject();
          } else {
            resolve();
          }
        });
      }));
    },
    obtenerTiposProyectos({rootState, commit}) {
      commit("LIMPIAR_TIPOS_PROYECTOS");

      return new Promise(((resolve, reject) => {
        rootState.loading++;
        base("tipos_proyectos").select().eachPage((records, fetchNextPage) => {
          commit("AGREGAR_TIPOS_PROYECTOS", records);
          fetchNextPage();
        }, (err) => {
          rootState.loading--;
          if (err) {
            console.error(err);
            reject();
          } else {
            resolve();
          }
        });
      }));
    },
    obtenerProyectos({rootState, commit}) {
      commit("LIMPIAR_PROYECTOS");

      return new Promise(((resolve, reject) => {
        rootState.loading++;
        base("proyectos").select({filterByFormula: `FIND('${rootState.presentacion.id}', idsPresentaciones)`}).eachPage((records, fetchNextPage) => {
          commit("AGREGAR_PROYECTOS", records);
          fetchNextPage();
        }, (err) => {
          rootState.loading--;
          if (err) {
            console.error(err);
            reject();
          } else {
            resolve();
          }
        });
      }));
    },
    obtenerConceptos({rootState, commit}) {
      commit("LIMPIAR_CONCEPTOS");

      return new Promise(((resolve, reject) => {
        rootState.loading++;
        base("conceptos").select({filterByFormula: `FIND('${rootState.presentacion.id}', idsPresentaciones)`}).eachPage((records, fetchNextPage) => {
          commit("AGREGAR_CONCEPTOS", records);
          fetchNextPage();
        }, (err) => {
          rootState.loading--;
          if (err) {
            console.error(err);
            reject();
          } else {
            resolve();
          }
        });
      }));
    },
    obtenerCondiciones({rootState, commit}) {
      commit("LIMPIAR_CONDICIONES");

      return new Promise(((resolve, reject) => {
        rootState.loading++;
        base("condiciones").select({filterByFormula: 'AND(cotizaciones)'}).eachPage((records, fetchNextPage) => {
          commit("AGREGAR_CONDICIONES", records);
          fetchNextPage();
        }, (err) => {
          rootState.loading--;
          if (err) {
            console.error(err);
            reject();
          } else {
            resolve();
          }
        });
      }));
    },
    obtenerTiposProductos({rootState, commit}) {
      commit("LIMPIAR_TIPOS_PRODUCTOS");

      return new Promise(((resolve, reject) => {
        rootState.loading++;
        base("tipos_productos").select().eachPage((records, fetchNextPage) => {
          commit("AGREGAR_TIPOS_PRODUCTOS", records);
          fetchNextPage();
        }, (err) => {
          rootState.loading--;
          if (err) {
            console.error(err);
            reject();
          } else {
            resolve();
          }
        });
      }));
    },
    obtenerProductos({rootState, commit}) {
      commit("LIMPIAR_PRODUCTOS");

      return new Promise(((resolve, reject) => {
        rootState.loading++;
        base("productos").select({filterByFormula: `FIND('${rootState.presentacion.id}', idsPresentaciones)`}).eachPage((records, fetchNextPage) => {
          commit("AGREGAR_PRODUCTOS", records);
          fetchNextPage();
        }, (err) => {
          rootState.loading--;
          if (err) {
            console.error(err);
            reject();
          } else {
            resolve();
          }
        });
      }));
    },
    registrarVisualizacion({rootState}, usuario) {
      axios.get('https://www.cloudflare.com/cdn-cgi/trace').then((response) => {
        let lines = response.data.split("\n");

        lines.forEach((line) => {
          if (line.search("ip=") > -1) {
            base('visualizaciones').create([
              {
                "fields": {
                  "ip": line.replace("ip=", ""),
                  "hora": new Date(),
                  "presentacion": [rootState.presentacion.id],
                  "usuario": [usuario.id],
                }
              }
            ]);
          }
        });
      });
    }
  },
  getters: {
    buscarCotizacion(state) {
      return (idCotizacion) => {
        return state.cotizaciones.length ? state.cotizaciones.find(cotizacion => {
          return cotizacion.id === idCotizacion
        }) : {};
      }
    },
    cotizacionesOrdenadas(state) {
      return orderBy(state.cotizaciones, 'fields.orden');
    },
    tiposProyectoFiltrados(state) {
      return (idCotizacion) => {
        return orderBy(state.tipos_proyectos.filter(tipoProyecto => {
          return tipoProyecto.fields.idsCotizaciones.includes(idCotizacion);
        }), 'fields.orden')
      }
    },
    proyectosFiltrados(state) {
      return (idCotizacion, idTipoProyecto) => {
        return orderBy(state.proyectos.filter(proyecto => {
          return proyecto.fields.cotizaciones.includes(idCotizacion) && proyecto.fields.tipo_proyecto.includes(idTipoProyecto);
        }), 'fields.orden');
      }
    },
    tiposProductosFiltrados(state) {
      return (idProyecto) => {
        return orderBy(state.tipos_productos.filter(tipoProducto => {
          return tipoProducto.fields.idsProyectos.includes(idProyecto);
        }), 'fields.orden');
      }
    },
    productosFiltrados(state) {
      return (idProyecto, idTipoProducto) => {
        return orderBy(state.productos.filter((producto) => {
          return producto.fields.idsProyectos.includes(idProyecto) && producto.fields.idTipoProducto === idTipoProducto;
        }), 'fields.orden');
      }
    },
    conceptosFiltrados(state) {
      return (idProyecto, idProducto) => {
        return orderBy(state.conceptos.filter(concepto => {
          return concepto.fields.producto.includes(idProducto) && concepto.fields.proyecto.includes(idProyecto);
        }), 'fields.orden');
      }
    },
    condicionesFiltradas(state) {
      return (idCotizacion) => {
        return orderBy(state.condiciones.filter(condicion => {
          return condicion.fields.cotizaciones.includes(idCotizacion);
        }), 'fields.orden');
      }
    },
  },
  modules: {}
})
